<template>
    <div class="white-box mt-3" style="padding: 35px;">
        <div class="data-group">
            <M3FormTitle title="Gantt activități" :checked="completed"></M3FormTitle>
        </div>
        <div class="ganntHeader">
            <span>Diagrama <b>GANTT</b></span>
        </div>
        <div v-for="(activity, key) in activitati" :key="key" class="chartRow">
            <span class="activityTitle row">Activitatea {{ activity.activity.number }} - {{ activity.activity.title }}</span>
            <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-1" style="text-align: center"><span><b>A {{ activity.activity.number }}</b></span></div>
                <div class="col-sm-11">
                    <div v-for="index in 18" :key="index" class="chartItem">
                        <div :style="index >= activity.date[0] && index < activity.date[1] ? {'background-color': activity.fillColor} : {'background-color': '#F6F6F6'}">&nbsp;</div>
                    </div>
                </div>
            </div>
            <div v-for="(child, childKey) in activity.activity.childrens" :key="childKey" class="row" style="margin-top:5px">
                <div class="col-sm-1" style="text-align: center; font-size: 0.75rem"><span><b>{{ activity.activity.number }}.{{ child.number }}.</b></span></div>
                <div class="col-sm-11">
                    <div v-for="index in 18" :key="index" class="chartItem">
                        <div :style="index >= child.date[0] && index < child.date[1] ? {'background-color': activity.fillColor, 'opacity': '0.6'} : {'background-color': '#F6F6F6'}">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    export default {
        components: {
            M3FormTitle
        },
        props: {
            activitati: {
                type: Array,
                default(){
                    return [];
                }
            }
        },
        data() {
            return {
                completed: true,
            }
        },
        computed: {
        },
        watch:{
        },
        mounted() {
        },
        methods:{
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}
.ganntHeader{
    width: 100%;
    background-color: #E9EAEC;
    height: 60px;
    padding-left: 30px;
    margin-bottom: 50px;
    color: #55556D;
    font-size: larger;
    display: flex;
    align-items: center;
}
.activityTitle{
  width: 100%;
  margin-bottom: 15px;
}
.chartItem{
    width: 5.45%;
    margin-right: 1px;
    float: left;
}
.chartRow{
    width: 100%;
    margin-bottom: 25px;
    padding-left: inherit;
}
@media screen and (max-width: 1280px) {
  .chartItem{
    width: 3.5%;
  }
}
</style>
